<div class="nova__dialog__toolbar">
    <div class="nova__dialog__toolbar__title">
        {{titleCaption}}
    </div>
</div>
<div [formGroup]="delegationFormGroup" mat-dialog-content class="nova__dialog__content">
    <ng-container *ngIf="!delegation">
        <mat-form-field appearance="outline" class="form-field">
            <input matInput type="text" placeholder="Add delegate*" #employeeSearchInput formControlName="employeeSearch" [matAutocomplete]="auto">
            <mat-autocomplete data-qa-id="DelegationAddEditEmployeeSearchInput" #auto="matAutocomplete"
                [displayWith]="employeeDisplay" (optionSelected)="employeeSelected($event)">
                <mat-option *ngFor="let employee of employees$ | async" [value]="employee">
                    {{ employee?.fullName }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </ng-container>
    <div class="delegated-user" *ngIf="delegation">
        <div class="flex-col">
            <div class="flex-row space-between items-center">
                <span class="delegated-user-name-label" data-qa-id="delegated-user-name">{{delegation.delegatedUser.name}}</span>
            </div>
            <div class="flex-row items-center">
                <span class="delegated-user-title-label" data-qa-id="delegated-user-title" *ngIf="delegation.delegatedUser.title">{{delegation.delegatedUser.title}}</span>
            </div>
        </div>
    </div>
    <div>
        <div class="delegation-types-label">Select the permission(s) for this delegate*</div>
        <div class="delegation-types flex-row-wrap space-between items-start">
            <mat-selection-list formControlName="delegationTypes" (selectionChange)="selectionChange($event)">
                @for (type of delegationTypes$ | async; track type.key) {
                    @if (type.key !== delegationTypeEnum.InAppImpersonation ||(auth0NovaLinkedProfilesSignal() && auth0NovaImpersonationSignal())) {
                        <mat-list-option
                            [value]="type.key"
                            checkboxPosition="before"
                            class="option-wrapper">
                            <span class="option">{{ type.value }}</span>
                        </mat-list-option>
                    }
                }
            </mat-selection-list>
        </div>
    </div>

    <div class="date-time-pickers">
        <div class="timeframe-label">Set a timeframe *</div>
        <div class="timeframe-help-text">Not setting an end date will classify your coverage as “ongoing”. You are required to manually stop your coverage.</div>
        @if(!novaDelegationTimeframeSignal()){
            <div class="flex-row space-between">
                <mat-form-field appearance="outline" class="date-picker">
                    <input matInput [matDatepicker]="startDatePicker" formControlName="delegationStartDate"
                    [min]="delegationDateValidationEnabled ? getStartMinDateValue() : null">>
                    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker data-qa-id="DelegationAddEditStartDatePicker" #startDatePicker></mat-datepicker>
                    <!-- Order of these validations matters, as some errors are more specific versions of others -->                         
                    @if (delegationDateValidationEnabled && delegationFormGroup.get('delegationStartDate')?.touched && delegationFormGroup.get('delegationStartDate')?.hasError('matDatepickerParse')) {
                            <mat-error>
                                Invalid date. Use MM/DD/YYYY format.
                            </mat-error>
                    }
                    @else if (delegationDateValidationEnabled && delegationFormGroup.get('delegationStartDate')?.touched && delegationFormGroup.get('delegationStartDate')?.hasError('required')) {
                        <mat-error>
                            Start Date is required.
                        </mat-error>
                    }
                    @else if (delegationDateValidationEnabled && delegationFormGroup.get('delegationStartDate')?.touched && delegationFormGroup.get('delegationStartDate')?.hasError('matDatepickerMin')) {
                        <mat-error>
                            Invalid input, must not be a past date
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field appearance="outline" class="date-picker">
                    <input matInput [matDatepicker]="endDatePicker" formControlName="delegationEndDate"
                        [min]="getEndMinDateValue()">
                    <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker data-qa-id="DelegationAddEditEndDatePicker" #endDatePicker></mat-datepicker>
                    <!-- Order of these validations matters, as some errors are more specific versions of others -->                         
                    @if (delegationDateValidationEnabled && delegationFormGroup.get('delegationEndDate')?.touched && delegationFormGroup.get('delegationEndDate')?.hasError('matDatepickerParse')) {
                            <mat-error>
                                Invalid date. Use MM/DD/YYYY format.
                            </mat-error>
                    }
                    @else if (delegationDateValidationEnabled && delegationFormGroup.get('delegationEndDate')?.touched && delegationFormGroup.get('delegationEndDate')?.hasError('matDatepickerMin')) {
                        <mat-error>
                            Invalid, must not be a past date or before start date
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        } @else {
            <div class="flex-row" >
                <div>
                    <mat-form-field appearance="outline" class="dateTimepicker">
                        <input matInput [matDatepicker]="startDatePicker" formControlName="delegationStartDate"
                            [min]="delegationDateValidationEnabled ? getStartMinDateValue() : null">
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker data-qa-id="DelegationAddEditStartDatePicker" #startDatePicker></mat-datepicker>                        
                        <!-- Order of these validations matters, as some errors are more specific versions of others -->                         
                        @if (delegationDateValidationEnabled && delegationFormGroup.get('delegationStartDate')?.touched && delegationFormGroup.get('delegationStartDate')?.hasError('matDatepickerParse')) {
                            <mat-error>
                                Invalid date. Use MM/DD/YYYY format.
                            </mat-error>
                        }
                        @else if (delegationDateValidationEnabled && delegationFormGroup.get('delegationStartDate')?.touched && delegationFormGroup.get('delegationStartDate')?.hasError('required')) {
                            <mat-error>
                                Start Date is required.
                            </mat-error>
                        }
                        @else if (delegationDateValidationEnabled && delegationFormGroup.get('delegationStartDate')?.touched && delegationFormGroup.get('delegationStartDate')?.hasError('matDatepickerMin')) {
                            <mat-error>
                                Invalid input, must not be a past date
                            </mat-error>
                        }
                    </mat-form-field>
                    <kendo-timepicker
                        data-qa-id="start_time"
                        class="flex-40 nova-kendo-timepicker ng-material-mimic time-input"
                        formControlName="delegationStartTime"
                        onkeydown="return false;"
                        format="HH:mm" placeholder="Start Time" [steps]="{ minute: 5 }">
                    </kendo-timepicker>
                </div>  
            </div>
            <div class="flex-row" >
                <div>
                    <mat-form-field appearance="outline" class="dateTimepicker">                
                        <input matInput [matDatepicker]="endDatePicker" formControlName="delegationEndDate"
                        [min]="getEndMinDateValue()">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker data-qa-id="DelegationAddEditEndDatePicker" #endDatePicker></mat-datepicker>
                        <!-- Order of these validations matters, as some errors are more specific versions of others -->                         
                        @if (delegationDateValidationEnabled && delegationFormGroup.get('delegationEndDate')?.touched && delegationFormGroup.get('delegationEndDate')?.hasError('matDatepickerParse')) {
                            <mat-error>
                                Invalid date. Use MM/DD/YYYY format.
                            </mat-error>
                        }
                        @else if (delegationDateValidationEnabled && delegationFormGroup.get('delegationEndDate')?.touched && delegationFormGroup.hasError('startDateAfterEndDate')) {
                            <mat-error>
                                Invalid, must not be before start date
                            </mat-error>
                        }
                        @else if (delegationDateValidationEnabled && delegationFormGroup.get('delegationEndDate')?.touched && delegationFormGroup.get('delegationEndDate')?.hasError('matDatepickerMin')) {
                            <mat-error>
                                Invalid input, must not be a past date
                            </mat-error>
                        }
                    </mat-form-field>
                    <kendo-timepicker
                        data-qa-id="end_time"
                        onkeydown="return false;"
                        class="flex-40 nova-kendo-timepicker ng-material-mimic time-input"
                        formControlName="delegationEndTime"
                        format="HH:mm" placeholder="End Time" [steps]="{ minute: 5 }">
                    </kendo-timepicker>
                </div>
            </div>
        }     
    </div>

    <div class="info-banner-wrap" [style.visibility]="showImpersonationWarningMessage ? 'visible' : 'hidden'">
        <div class="info-banner">
            <mat-icon class="info-banner__icon">info</mat-icon>
            <span class="info-banner__text"><strong>Important! You are granting impersonation access. </strong><br>
                This will allow the designated user to act as you, with the same permissions and access.
            </span>
        </div>
    </div>
    
    <mat-dialog-actions class="nova__dialog__content__actions">
        <button data-qa-id="DelegationAddEditSaveButton" mat-flat-button color="primary" [disabled]="!delegationFormGroup.valid || !delegationFormGroup.dirty" (click)="saveDelegation()">
            {{saveCaption}}
        </button>
        <button data-qa-id="DelegationAddEditCancelButton" mat-flat-button color="cancel" [mat-dialog-close]="false">
            Cancel
        </button>
    </mat-dialog-actions>
</div>
